import axios from 'axios';

const setAnsweringDefaultEnabled = async (
  subscriptionId: string,
  defaultEnabled: boolean,
) => {
  await axios.post(`/answering_service/${subscriptionId}/default_enabled`, {
    defaultEnabled,
  });
};

export default setAnsweringDefaultEnabled;
